import React, { useEffect, useState } from "react";
import {
    AppStoreButton,
    DesktopButton,
    FDroidButton,
    PlayStoreButton,
    WebButton,
} from "./DownloadButtons";
import { DownloadURL } from "constants/download";
import { URLwithUTMSuffix } from "utils/download";
import { useTranslation } from "react-i18next";
import footerBlob from "images/homepage/footer-blob.png";
import footerBlobMobile from "images/homepage/footer-blob-mobile.png";
import { getDeviceOS, OS } from "utils/detect-os";

interface FooterDownloadProps {
    footerHeading?: string;
    footerSubheading?: string;
}

const FooterDownloads: React.FC<FooterDownloadProps> = ({
    footerHeading,
    footerSubheading,
}) => {
    const { t, i18n } = useTranslation();

    const [mobileCTAButtonOS, setMobileCTAButtonOS] = useState<string>("");

    useEffect(() => {
        const os = getDeviceOS();

        if (os === OS.Android) {
            setMobileCTAButtonOS("Android");
        } else if (os === OS.IOS) {
            setMobileCTAButtonOS("iOS");
        }
    }, []);

    return (
        <div
            id="download"
            className="mx-6 mt-28 flex flex-col md:mt-44 lg:mt-52 lg:max-w-[1320px] xl:mx-auto xl:mt-48 xl:w-full"
        >
            <div className="flex flex-col items-center">
                <div className="relative flex w-full flex-col items-center justify-center">
                    <img
                        src={footerBlob}
                        className="hidden w-full md:block xl:w-[1000px]"
                    />
                    <img
                        src={footerBlobMobile}
                        className="block w-full md:hidden xl:w-[1000px]"
                    />
                    <div className="absolute flex w-[70%] flex-col items-center justify-center gap-3 text-center md:gap-2! xl:gap-3!">
                        <span className="w-[85%] text-3xl leading-7 font-semibold tracking-tighter text-white md:w-[70%] md:text-4xl md:leading-10 lg:text-5xl lg:leading-13 xl:w-[800px] xl:text-6xl xl:leading-16">
                            {footerHeading}
                        </span>
                        <span className="w-[80%] leading-5 text-white xl:text-2xl">
                            {footerSubheading}
                        </span>
                    </div>
                </div>
                <div className="mt-5 hidden flex-col items-center justify-center gap-3 md:flex">
                    <div className="flex flex-row justify-between gap-3">
                        <AppStoreButton
                            link={URLwithUTMSuffix(DownloadURL.appStore)}
                            source={`photos-footer-downloads`}
                            lang={i18n.language}
                            width={290}
                            height={120}
                        />
                        <PlayStoreButton
                            link={URLwithUTMSuffix(DownloadURL.googlePlay)}
                            source={`photos-footer-downloads`}
                            lang={i18n.language}
                            width={320}
                            height={160}
                        />
                    </div>
                    <div className="flex flex-row justify-between gap-3">
                        <FDroidButton
                            link={DownloadURL.fDroid}
                            source={`photos-footer-downloads`}
                            lang={i18n.language}
                            width={197}
                            height={70}
                        />
                        <WebButton
                            link={DownloadURL.web}
                            source={`photos-footer-downloads`}
                            lang={i18n.language}
                            width={197}
                            height={59}
                        />
                        <DesktopButton
                            link={
                                i18n.language === "en"
                                    ? "/download/desktop"
                                    : `/${i18n.language}/download/desktop`
                            }
                            source={`photos-footer-downloads`}
                            lang={i18n.language}
                            width={197}
                            height={59}
                        />
                    </div>
                </div>
                <div className="mt-5 flex flex-col items-center justify-center gap-3 md:hidden">
                    {mobileCTAButtonOS === "iOS" ? (
                        <AppStoreButton
                            link={URLwithUTMSuffix(DownloadURL.appStore)}
                            source={`photos-footer-downloads`}
                            lang={i18n.language}
                            width={197}
                            height={70}
                        />
                    ) : (
                        <PlayStoreButton
                            link={URLwithUTMSuffix(DownloadURL.googlePlay)}
                            source={`photos-footer-downloads`}
                            lang={i18n.language}
                            width={197}
                            height={59}
                        />
                    )}
                    <a
                        href={`${i18n.language === "en" ? "/download" : `/${i18n.language}/download`}`}
                        className="mt-1 font-medium! text-[#878787]!"
                    >
                        {t("EP_INDEX_FOOTER_DOWNLOADS_MORE_PLATFORMS")}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FooterDownloads;
